module.exports = __webpack_public_path__ + "static/media/illustration.9d2db937.png";